
    let testimonialSlider;

    const initTestimonialsSlider = () => {
        testimonialSlider = new Swiper('.swiper.testimonials__slider', {
          slidesPerView: 1,
          effect: 'fade',
          autoplay: {
            delay: 3000,
            disableOnInteraction: false
          }
        });
    }
  
    const destroyTestimonialsSlider = () => {
      if (testimonialSlider !== undefined) {
        testimonialSlider.destroy(true, true);
      }
    };

    document.addEventListener('DOMContentLoaded', function () {
        initTestimonialsSlider();
      
    });
